import React from 'react';
import { SearchOutlined } from '@ant-design/icons';

import { Typography } from 'redpoints-front-components/index';

import './NoFilterApplied.less';

const NoFilterApplied = ({ title, description }) => (
  <div className="no-filter__container">
    <div className="no-filter__icon">
      <SearchOutlined />
    </div>
    <Typography blockTypes={['title2']}>{title}</Typography>
    <Typography blockTypes={['title4']}>{description}</Typography>
  </div>
);

export default NoFilterApplied;
